module.exports = __webpack_public_path__ + "img/icon-download@3x.fa0e60a4.png";